/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import Amount from '../transaction/Amount'
import { Table, TableTfootProps } from '@mantine/core'

export type ManagementReportBalanceProps = TableTfootProps & {
  data: {
    balance: number
    expenses: number
    revenues: number
    cps?: number
    vat: number
  }
}

function ManagementReportBalance (props: ManagementReportBalanceProps) {
  const { data, ...others } = props
  const intl = useIntl()
  return (
    <Table.Tfoot {...others}>
      <Table.Tr>
        <Table.Td colSpan={3} />
        <Table.Th
          scope="col"
          ta="end"
          w={120}
        >
          <FormattedMessage
            id="revenues_including_taxes"
            defaultMessage="Revenus TTC"
          />
        </Table.Th>
        <Table.Th
          scope="col"
          ta="end"
          w={120}
        >
          <FormattedMessage
            id="expenses_including_taxes"
            defaultMessage="Dépenses TTC"
          />
        </Table.Th>
        <Table.Th
          scope="col"
          ta="end"
          w={120}
        >
          <FormattedMessage
            id="including_vat"
            defaultMessage="Dont TVA"
          />
        </Table.Th>
        <Table.Th
          scope="col"
          ta="end"
          w={120}
        >
          <FormattedMessage
            id="including_cps"
            defaultMessage="Dont CPS"
          />
        </Table.Th>
      </Table.Tr>
      <Table.Tr>
        <Table.Th colSpan={3}>
          {intl.formatMessage({
            id: 'total',
            defaultMessage: 'Total'
          })}
        </Table.Th>
        <Table.Td ta="end">
          <Amount value={data.revenues} inherit />
        </Table.Td>
        <Table.Td ta="end">
          <Amount value={data.expenses} inherit />
        </Table.Td>
        <Table.Td ta="end">
          <Amount value={data.vat} inherit />
        </Table.Td>
        <Table.Td ta="end">
          <Amount value={data.cps} inherit />
        </Table.Td>
      </Table.Tr>
      <Table.Tr>
        <Table.Th colSpan={3}>
          {intl.formatMessage({
            id: 'balance',
            defaultMessage: 'Solde'
          })}
        </Table.Th>
        <Table.Td ta="end">
          {data.balance >= 0
            ? <Amount inherit value={data.balance} colored />
            : null}
        </Table.Td>
        <Table.Td ta="end">
          {data.balance < 0
            ? <Amount inherit value={data.balance} colored />
            : null}
        </Table.Td>
        <Table.Td />
        <Table.Td />
      </Table.Tr>
    </Table.Tfoot>
  )
}

export default ManagementReportBalance
